import * as types from "./types";
import {
    getBatchProductionListAxios,
    postBatchProductionAxios,
    putBatchProductionAxios,
    deleteBatchProductionAxios,
} from "./services";


export async function getBatchProductionListAction({ commit }) {
    commit(types.LOADING_BATCH_PRODUCTION, true);
    try {
      const { data } = await getBatchProductionListAxios();
      console.log('batchProduction', data.result);
      commit(types.GET_BATCH_PRODUCTION_LIST, data.result);
    } catch (e) {
  
      throw e;
    } finally {
      commit(types.LOADING_BATCH_PRODUCTION, false);
    }
}

export async function addBatchProductionAction({ commit }, payload) {
  commit(types.LOADING_BATCH_PRODUCTION, true);
  try {
    const { data } = await postBatchProductionAxios(payload);
    payload.id = data.result.id;
    commit(types.ADD_BATCH_PRODUCTION, payload);
  } catch (e) {
 
    throw e;
  } finally {
    commit(types.LOADING_BATCH_PRODUCTION, false);
  }
}

export async function updateBatchProductionAction({ commit }, payload) {
  commit(types.LOADING_BATCH_PRODUCTION, true);
  try {
    await putBatchProductionAxios(payload);
    commit(types.UPDATE_BATCH_PRODUCTION, payload);
  } catch (e) {

    throw e;
  } finally {
    commit(types.LOADING_BATCH_PRODUCTION, false);
  }
}

export async function removeBatchProductionAction({ commit }, payload) {
  commit(types.LOADING_BATCH_PRODUCTION, true);
  try {
    await deleteBatchProductionAxios(payload);
    commit(types.REMOVE_BATCH_PRODUCTION, payload);
  } catch (e) {

    throw e;
  } finally {
    commit(types.LOADING_BATCH_PRODUCTION, false);
  }
}


  